import type { InventoryRulesConfig, StockReserveScope } from '../types/config';

export function stockReserveScope(
  inventoryRules: Pick<InventoryRulesConfig, 'stock_reserve_scope'> | undefined,
): StockReserveScope {
  return inventoryRules?.stock_reserve_scope === 'first_order_and_month' ? 'first_order_and_month' : 'first_order';
}

export function reserveIncludesMonth(scope: StockReserveScope, isTransition: boolean): boolean {
  return isTransition && scope === 'first_order_and_month';
}

export interface ReserveHorizonArgs {
  scope: StockReserveScope;
  isTransition: boolean;
  /** Energy-equivalent days of full ration the initiation pack covers. */
  initiationEquivalentDays: number;
  subscriptionDays: number;
}

// Days of full ration one recipe share must be in stock for: the front-end estimate of
// the backend `required_units` rule (initiation pack in transition, else the monthly;
// plus the monthly when the scope also covers the month after a transition pack).
export function reserveHorizonDays({
  scope,
  isTransition,
  initiationEquivalentDays,
  subscriptionDays,
}: ReserveHorizonArgs): number {
  const firstOrder = isTransition ? initiationEquivalentDays : subscriptionDays;
  return firstOrder + (reserveIncludesMonth(scope, isTransition) ? subscriptionDays : 0);
}
